import { useState, useMemo, useEffect } from 'react'
import { useAppDispatch } from '@/store/hooks'
import { updateStatusSaga } from '@/store/workspace/workspaceSlice'
import { debounce } from '@/utils/debounce'
import { DEBOUNCE_INPUT_TIME } from '@/const/config'
import Input from '@/components/ui/Input/Input'

interface StatusNameInputProps {
    statusId: string
    name: string
    disabled?: boolean
}

const StatusNameInput = ({ statusId, name, disabled }: StatusNameInputProps) => {
    const dispatch = useAppDispatch()
    const [value, setValue] = useState(name)

    useEffect(() => { setValue(name) }, [name])

    const debouncedSave = useMemo(() => debounce((newName: string) => {
        dispatch(updateStatusSaga({ statusId, data: { name: newName } }))
    }, DEBOUNCE_INPUT_TIME), [dispatch, statusId])

    useEffect(() => () => debouncedSave.cancel(), [debouncedSave])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value
        setValue(newValue)
        if (newValue.trim()) {
            debouncedSave(newValue.trim())
        }
    }

    return <Input value={value} onChange={handleChange} disabled={disabled} />
}

export default StatusNameInput
